const ServicesHero = () => {
  return (
    <section className="pt-32 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
          OUR SERVICES
        </p>
        <h1 className="font-serif text-5xl lg:text-6xl font-bold text-navy-primary mb-8 max-w-4xl mx-auto leading-tight">
          Comprehensive Solutions for Clinical Practice Excellence
        </h1>
        <p className="text-lg text-charcoal max-w-3xl mx-auto leading-relaxed">
          From operational optimization to digital transformation and strategic
          growth, we deliver end-to-end consulting services tailored to modern
          clinical organizations.
        </p>
      </div>
    </section>
  );
};

export default ServicesHero;